export const setWorkCredential = (base64) => ({
  type: 'SET_WORK_CREDENTIAL',
  payload: base64,
});

export const clearWorkCredential = () => ({
  type: 'CLEAR_WORK_CREDENTIAL',
});
